import { SVGProps } from 'react';

export const Feedback = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.7826 5.91482H5.15652C4.93212 5.91482 4.75 6.09694 4.75 6.32134V10.3866C4.75 10.611 4.93212 10.7931 5.15652 10.7931H6.7826C7.007 10.7931 7.18912 10.611 7.18912 10.3866V6.32134C7.18912 6.09694 7.007 5.91482 6.7826 5.91482ZM14.0055 5.65294C13.9283 5.56026 13.8141 5.507 13.6933 5.507H11.2542V3.88091C11.2542 3.65651 11.0725 3.47439 10.8477 3.47439H9.62814C9.46594 3.47439 9.31878 3.57114 9.25495 3.72034L8.00206 6.32004V10.1726L9.47732 10.7625C9.52529 10.7816 9.57651 10.7918 9.62814 10.7918H12.8803C13.0771 10.7918 13.2454 10.6511 13.2803 10.4576L14.0934 5.98588C14.1153 5.86759 14.0828 5.74563 14.0055 5.65294ZM15.8 0.5H2.2C1.2616 0.5 0.5 1.2616 0.5 2.2V12.4C0.5 13.3384 1.2616 14.1 2.2 14.1H3.05V17.5L6.45 14.1H15.8C16.7384 14.1 17.5 13.3384 17.5 12.4V2.2C17.5 1.2616 16.7384 0.5 15.8 0.5Z"
      fill="currentColor"
    />
  </svg>
);
